import {
	IHistoryDownloadItem,
	IHistoryTableRowData,
	IHistoryTask
} from '@/types/history.interface'
import { IFile } from '@/types/task.interface'
import { formatDate } from '@/utils/formatDate'

type THistoryFileName = Exclude<IFile['name'], 'TXT'>

const HISTORY_FILE_ORDER: THistoryFileName[] = ['MP4', 'SRT en', 'SRT']

const HISTORY_FILE_LABELS: Record<THistoryFileName, string> = {
	MP4: '↓ mp4',
	'SRT en': '↓ SRT en',
	SRT: '↓ SRT'
}

export const mapHistoryFilesToDownloads = (
	files?: IFile[]
): IHistoryDownloadItem[] => {
	if (!files?.length) return []

	const downloads = HISTORY_FILE_ORDER.reduce<IHistoryDownloadItem[]>(
		(acc, type) => {
			const file = files.find(item => item.name === type)

			if (!file) return acc

			acc.push({
				type,
				label: HISTORY_FILE_LABELS[type],
				href: file.source,
				filename: file.filename
			})

			return acc
		},
		[]
	)

	return downloads
}

export const mapHistoryTaskToRow = (
	task: IHistoryTask
): IHistoryTableRowData => {
	return {
		key: task.celery_id,
		id: task.task_id ?? task.result?.task_id ?? '-',
		listener: task.source || '-',
		userName: task.created_by || '-',
		startedAt: formatDate(task.started_at) || '-',
		finishedAt: formatDate(task.finished_at) || '-',
		runtime:
			typeof task.runtime === 'number' ? `${task.runtime.toFixed(2)} sec` : '-',
		status: task.status,
		downloads: mapHistoryFilesToDownloads(task.files ?? task.result?.files),
		errorMessage: task.result?.error || null
	}
}

export const mapHistoryTasksToRows = (
	tasks: IHistoryTask[] = []
): IHistoryTableRowData[] => {
	const rows = tasks.map(mapHistoryTaskToRow)

	return rows
}
